/* jshint camelcase:false */
/* global $ */
'use strict';

function Login(EVENTS, MODALS) {
	window.NIKE = window.NIKE || {};
	window.NIKE.lang = window.NIKE.lang || 'en';
	window.NIKE.country = window.NIKE.country || 'GB';
	window.NIKE.token = '';
	var PubSub = require('pubsub-js');
	var nike = window.nike || {};
	var $loader = $('.loading-box');
	var loaderEnabled = 'loading-box--enabled';

	// Login event listeners
	window.nikeUniteInit = function () {
		PubSub.publish(EVENTS.LOGIN_LOADED);
		nike.unite.on.login.success.handlers.add(function (result) {
				PubSub.publish(EVENTS.LOGIN);
				window.NIKE.uuid = result.uuid;
				window.NIKE.isLoggedIn = true;
				window.NIKE.token = result.access_token;
				PubSub.publish(EVENTS.IMAGE_SEND, window.NIKE.token);
			});
		nike.unite.on.join.success.handlers.add(function (result) {
				PubSub.publish(EVENTS.LOGIN);
				window.NIKE.uuid = result.uuid;
				window.NIKE.isLoggedIn = true;
				window.NIKE.token = result.access_token;
				PubSub.publish(EVENTS.IMAGE_SEND, window.NIKE.token);
			});
		nike.unite.on.login.fail.handlers.add(function (result) {
				console.log('Login fail: ', result);
			});
		nike.unite.on.resetPassword.success.handlers.add(function () {
			location.reload();
		});
		nike.unite.on.join.fail.handlers.add(function (result) {
			console.log('Join fail: ', result);
		});
	};

	(function () {
		var scriptEl = document.getElementsByTagName('script')[0];
		var scriptNikeLogin = document.createElement('script');
		scriptNikeLogin.src = '//s3.nikecdn.com/unite/scripts/unite.min.js';
		scriptNikeLogin.setAttribute('id', 'nike-unite');
		scriptNikeLogin.setAttribute('data-clientid', '0wE3kKNl0Gp2ZYGgQG0yFHOUVgXYBFIo');
		scriptNikeLogin.setAttribute('data-cdn', '//s3.nikecdn.com/unite');
		scriptNikeLogin.setAttribute('data-defaultview', 'login');
		scriptNikeLogin.setAttribute('data-uxid', 'com.nike.brand.wesocialassetgen.web');
		scriptNikeLogin.setAttribute('data-locale', window.NIKE.lang + '_' + window.NIKE.country);
		scriptNikeLogin.setAttribute('data-allowqueryparams', 'true');
		scriptEl.parentNode.insertBefore(scriptNikeLogin, scriptEl);

		scriptNikeLogin.onerror = function () {
			PubSub.publish(EVENTS.MODAL_OPEN, MODALS.ERROR_PROCESS);
			$loader.removeClass(loaderEnabled);
		};

	})();
}

module.exports = Login;
